import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/maxfly-logo.png';

const Logo = ({ className = '', style = {}, linkTo = '/', height = '70px' }) => {
  const logoContent = (
    <div className={`logo-container ${className}`} style={{ display: 'flex', alignItems: 'center', ...style }}>
      <img 
        src={logoImage} 
        alt="Maxfly Logo" 
        style={{ 
          height: height, 
          width: 'auto',
          objectFit: 'contain'
        }} 
      />
    </div>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} style={{ textDecoration: 'none' }}>
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;

